/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_Event_Group_Type_Audio_DescriptionInputs */



/**
* | output |
* | --- |
* | "Audio Description" |
*
* @param {Edit_Event_Group_Type_Audio_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const edit_event_group_type_audio_description = /** @type {((inputs?: Edit_Event_Group_Type_Audio_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_Event_Group_Type_Audio_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Description audio")
	if (locale === "de") return /** @type {LocalizedString} */ ("Audiobeschreibung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Descrizione audio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Аудиоописание")
	if (locale === "es") return /** @type {LocalizedString} */ ("Descripción de audio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("音频描述")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オーディオ説明")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑडियो विवरण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Descrição em áudio")
	return /** @type {LocalizedString} */ ("Audio Description")
});